import { render } from "./RolesAndResponsibilitiesByIdView.vue?vue&type=template&id=66181a78&scoped=true"
import script from "./RolesAndResponsibilitiesByIdView.vue?vue&type=script&lang=js"
export * from "./RolesAndResponsibilitiesByIdView.vue?vue&type=script&lang=js"

import "./RolesAndResponsibilitiesByIdView.vue?vue&type=style&index=0&id=66181a78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66181a78"]])

export default __exports__